export enum GmailEventType {
    messageRead = "messageRead",
    messageSent = "sent",
    recipientsUpdate = "recipientsChanged",
    composeRestore = "messageComposeRestored",
    composeMinimize = "composeViewUnfocused",
    composeViewUnfocused = "composeViewUnfocused",
    draftDestroy = "messageDestroy",
}
